import { useTranslation } from 'react-i18next'
import SimpleApplyCancelDialog from '@/components/common/dialog/SimpleApplyCancelDialog'
import { Befehlsnachricht } from '@/models/Befehlsnachricht'
import { useBfnStore } from '@/store/useBfnStore'
import { MarkRedrawnIcon24 } from '@repo/ui'

export interface BfnManuellWiderrufenDialogProps {
  befehlsnachricht: Befehlsnachricht
  state: boolean
  onClose: () => void
  'data-testid': string
}

// noinspection JSUnusedGlobalSymbols
export default function BfnManuellWiderrufenDialog({
  befehlsnachricht,
  state,
  onClose,
  'data-testid': testId
}: Readonly<BfnManuellWiderrufenDialogProps>) {
  const { t } = useTranslation('bfnDetails')
  const { setManuellWiderrufenAt } = useBfnStore()

  const onApply = () => {
    setManuellWiderrufenAt(befehlsnachricht.id, new Date())
  }

  return (
    <SimpleApplyCancelDialog
      title={t('dialog.manuell_widerrufen.title')}
      state={state}
      onApply={onApply}
      onCancel={onClose}
      applyButtonDisabled={false}
      applyButtonIcon={MarkRedrawnIcon24}
      applyButtonText={t('dialog.manuell_widerrufen.apply')}
      cancelButtonText={t('dialog.manuell_widerrufen.cancel')}
      data-testid={testId}
    >
      <p data-testid={`${testId}-text`}>
        {t('dialog.manuell_widerrufen.text')}
      </p>
    </SimpleApplyCancelDialog>
  )
}
